import { UserType, USER_TYPES } from '../../lib/contexts/UserType';
import { UiKit } from '@datavant/idsb-shared/uikit';
import { DebugRadioGroup } from './DebugRadioGroup';
import React from 'react';

export const DebugPopoverBody = (props: {
    decisionState: UserType;
    onUserTypeChanged: (user: UserType['user']) => void;
}): JSX.Element => (
    <UiKit.Chakra.PopoverBody pb={UiKit.consistency.buffer}>
        <UiKit.Chakra.VStack align={'stretch'} spacing={UiKit.consistency.buffer}>
            <UiKit.Text.BodyRegular>
                Use these controls to experiment with different user types.
            </UiKit.Text.BodyRegular>
            <UiKit.Text.BodyRegular>User type</UiKit.Text.BodyRegular>
            <DebugRadioGroup
                // @ts-expect-error - TS2322 - Type '(user: TenantType) => void' is not assignable to type '(newValue: string) => void'.
                onValueSelected={props.onUserTypeChanged}
                value={props.decisionState.user}
                options={USER_TYPES}
            />
        </UiKit.Chakra.VStack>
    </UiKit.Chakra.PopoverBody>
);
